import {yupResolver} from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React, {useState, useRef} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {Form, Popup, Button, Icon} from 'semantic-ui-react';
import * as yup from 'yup';

import QrCode from './QrCode';

import styles from './QrCodeCreateForm.module.scss';

const formSchema = yup.object().shape({
  siteUrl: yup
    .string()
    .url('Site URL must be a valid URL')
    .required('Site URL is required'),
});

const defaultFormValues = {
  siteUrl: '',
};

const QrCodeCreateForm = ({loading}) => {
  const [siteUrl, setSiteUrl] = useState('');
  const [qrKey, setQrKey] = useState(0);
  const [showQr, setShowQr] = useState(false);
  const qrRef = useRef();

  const {
    control,
    handleSubmit,
    watch,
    formState: {isValid, isDirty, isSubmitting},
  } = useForm({
    mode: 'onChange',
    defaultValues: defaultFormValues,
    resolver: yupResolver(formSchema),
  });

  watch('siteUrl');

  const onSubmit = ({siteUrl}) => {
    setSiteUrl(siteUrl);
    setQrKey(prev => prev + 1);
    setShowQr(true);
  };

  const handleReset = () => {
    setSiteUrl('');
    setShowQr(false);
    setQrKey(0);
  };

  const handleDownload = () => {
    qrRef.current?.download(); // Call the method exposed by QrCode
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} loading={isSubmitting || loading}>
        <Controller
          control={control}
          name="siteUrl"
          render={({field: {onChange, value, name}, fieldState: {error}}) => (
            <Popup
              trigger={
                <Form.Input
                  id="siteUrl"
                  label="Site URL"
                  error={error?.message}
                  required
                  name={name}
                  value={value}
                  disabled={showQr}
                  placeholder="https://my-site-at-cern.web.cern.ch"
                  onChange={(_e, data) => {
                    setSiteUrl(data.value);
                    onChange(data.value);
                  }}
                />
              }
              position="left center"
            >
              <Popup.Content>Specify the site URL for the QR code.</Popup.Content>
            </Popup>
          )}
        />

        {!showQr && (
          <Button
            primary
            type="submit"
            className={styles.ActionButton}
            floated="right"
            disabled={!isValid || !isDirty || isSubmitting || loading}
          >
            Generate QR Code
          </Button>
        )}
      </Form>

      {showQr && <QrCode key={qrKey} url={siteUrl} ref={qrRef} />}

      {showQr && (
        <div className={styles.ActionButtons}>
          <Button
            basic
            icon
            labelPosition="left"
            style={{marginBottom: 0}}
            onClick={() => {
              handleReset();
            }}
          >
            <Icon name="refresh" />
            Regenerate QR Code
          </Button>
          <Button
            primary
            icon
            labelPosition="right"
            style={{marginBottom: 0}}
            disabled={!showQr || isSubmitting || loading}
            onClick={() => {
              handleDownload();
            }}
          >
            <Icon name="download" />
            Download
          </Button>
        </div>
      )}
    </>
  );
};

QrCodeCreateForm.propTypes = {
  loading: PropTypes.bool,
};

export default QrCodeCreateForm;
